import { SystemIcon } from '@monorepo/nova-icons';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import { getDialogBlurStyles } from './dialog-blur.styles';

export const StyledSocialShareModal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    position: 'relative',
    padding: theme.spacing(6, 4),
    overflow: 'visible',
    boxShadow: 'none',

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(12),
    },
    ...getDialogBlurStyles(theme, { smallBlur: true }),
  },
}));

export const StyledSharingInfo = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(6),
  },
}));

export const StyledInputContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  position: 'relative',
  gap: theme.spacing(2),
  order: 2,
  marginBottom: 0,
  [theme.breakpoints.up('sm')]: {
    display: 'block',
    flexDirection: 'static',
    gap: 0,
    order: 0,
    marginBottom: theme.spacing(6),
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root.MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
  },
  '& .MuiOutlinedInput-notchedOutline.MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.text.fourth,
    borderRadius: theme.shape.borderRadius,
  },
  '& .MuiInputBase-input': {
    height: theme.spacing(6.5),
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(16),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    overflow: 'hidden',
  },
}));

export const StyledCopyButton = styled(Button)(({ theme }) => ({
  position: 'static',
  top: 0,
  right: 0,
  minWidth: '100%',
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  fontWeight: 'medium',
  [theme.breakpoints.up('sm')]: {
    position: 'absolute',
    minWidth: 'auto',
  },
}));

export const StyledInfoBox = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  order: 1,
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    textAlign: 'center',
    order: 0,
    marginBottom: 0,
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: 0,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: theme.typography.pxToRem(28),
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(42),
  },
}));

export const StyledCloseIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(4),
  right: theme.spacing(4),
  zIndex: 100,
}));

export const StyledDialogContent = styled(DialogContent)(() => ({
  padding: 0,
}));

export const StyledDescriptionTypography = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    textAlign: 'center',
    textWrap: 'balance',
  },
}));

export const StyledShareViaTypography = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(4),
  fontWeight: 600,
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(6),
  },
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  marginTop: theme.spacing(6),
  border: 0,
  padding: 0,
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(8),
  },
}));

export const StyledSharingOptionsContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
  },
}));

export const StyledSharingOptionsStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  alignItems: 'center',
  rowGap: theme.spacing(4),
  columnGap: theme.spacing(8),
  [theme.breakpoints.up('sm')]: {
    rowGap: theme.spacing(8),
    columnGap: theme.spacing(20),
  },
}));

export const StyledSharingOptionButton = styled(Button)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: theme.spacing(23),
  height: theme.spacing(21),
  borderRadius: theme.shape.borderRadius,
  padding: 0,
}));

export const StyledSharingOptionIcon = styled(SystemIcon)(() => ({
  fontSize: 36,
}));
